'use strict';
var angular = require('angular');
var CreditCardService = /** @class */ (function () {
    function CreditCardService($http, $log, Auth) {
        'ngInject';
        this.cardTypes = [
            { typeId: 0, name: 'Visa', typeName: 'visa' },
            { typeId: 1, name: 'Mastercard', typeName: 'mastercard' },
            { typeId: 2, name: 'American Express', typeName: 'amex' },
            { typeId: 3, name: 'Discover', typeName: 'discover' }
        ];
        this.aresCardTypeMap = {
            'Visa': 0,
            'MC': 1,
            'Amex': 2,
            'Discover': 3
        };
        this.akrisCardTypeMap = {
            'Visa': 1,
            'MC': 2,
            'Amex': 3,
            'Discover': 4
        };
        this.paymentTypes = [
            'CreditCard',
            'Terms',
            'COD',
            'Prepaid'
        ];
        this.$http = $http;
        this.$log = $log;
        this.Auth = Auth;
        this.getCredential();
    }
    CreditCardService.prototype.getCredential = function () {
        var _this = this;
        this.Auth.getToken().then(function (data) {
            _this.bearerToken = data;
        });
        this.Auth.getUserEmail().then(function (email) {
            _this.userEmail = email;
        });
        this.Auth.getConfigUrl().then(function (config) {
            _this.akrisPaymentAPI = config.awsAkrisServiceUrlPattern.replace('{ServiceName}', 'payment');
        });
    };
    CreditCardService.prototype.getCreditCards = function () {
        var self = this;
        return this.$http.get('api/account/payments')
            .then(function success(response) {
            return response.data.response;
        }, function error(response) {
            self.$log.error('error response.....', response);
        });
    };
    CreditCardService.prototype.getCardType = function (typeId) {
        switch (typeId) {
            case 0:
                return 'Visa';
            case 1:
                return 'MC';
            case 2:
                return 'Amex';
            case 3:
                return 'Discover';
            default:
                return 'Visa';
        }
    };
    CreditCardService.prototype.getCardNumber = function (typeId) {
        switch (typeId) {
            case 0:
                return '4111111111111111';
            case 1:
                return '5555555555554444';
            case 2:
                return '378282246310005';
            case 3:
                return '6011111111111117';
            default:
                return '4111111111111111';
        }
    };
    CreditCardService.prototype.getCreditCardTypes = function () {
        return this.cardTypes;
    };
    CreditCardService.prototype.addCreditCard = function (creditCard) {
        var _this = this;
        this.Auth.clearAccountCache();
        var self = this;
        if (creditCard.creditCardId) {
            return self.updateCreditCard(creditCard);
        }
        else {
            var expirationDate = creditCard.expirationDate.split('/'); // format expiration date as [month, year]
            if (expirationDate[0].length === 4) {
                var temp = expirationDate[0];
                expirationDate[0] = expirationDate[1];
                expirationDate[1] = temp;
            }
            var newCreditCard = {
                'nickname': creditCard.cardNickName,
                'creditCardType': this.akrisCardTypeMap[creditCard.cardType],
                'cardholderName': creditCard.nameOnCard,
                'cardholderEmail': this.userEmail,
                'primaryAccountNumber': creditCard.cardNumber,
                'cardVerificationValue': null,
                'expirationMonth': expirationDate[0],
                'expirationYear': expirationDate[1],
                'billingAddress': {
                    'recipientName': creditCard.firstName.replace(/\s+/g, '') + ' ' + creditCard.lastName.replace(/\s+/g, ''),
                    'street1': creditCard.address1,
                    'street2': creditCard.address2,
                    'city': creditCard.city,
                    'regionCode': creditCard.state,
                    'postalCode': creditCard.postalCode,
                    'countryCode': creditCard.countryCode
                }
            };
            return this.$http({
                method: 'POST',
                url: this.akrisPaymentAPI + '/CreditCards',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                    'authorization': 'Bearer' + ' ' + this.bearerToken
                },
                data: newCreditCard
            }).then(function (response) {
                if (response && response.data) {
                    var akrisCreditCardId = response.data.body;
                    return _this.$http({
                        method: 'GET',
                        url: _this.akrisPaymentAPI + '/CreditCards/' + akrisCreditCardId,
                        headers: {
                            'Content-Type': 'application/json-patch+json',
                            'authorization': 'Bearer' + ' ' + _this.bearerToken
                        }
                    }).then(function (response) {
                        if (response && response.data) {
                            var creditCardId = response.data.body.commerceServerCreditCardId;
                            if (creditCard.isDefaultPayment) {
                                _this.$http({
                                    method: 'PUT',
                                    url: '/api/account/payments/default/' + creditCardId
                                });
                            }
                            var newPayment = {
                                paymentType: 'CreditCard',
                                creditCardId: creditCardId,
                                last4Digits: '' + creditCard.cardNumber.substr(creditCard.cardNumber.length - 4),
                                cardNickName: creditCard.cardNickName,
                                cardType: _this.aresCardTypeMap[creditCard.cardType],
                                isDefaultPayment: creditCard.isDefaultPayment
                            };
                            return newPayment;
                        }
                    });
                }
            });
        }
    };
    CreditCardService.prototype.deleteCreditCard = function (creditCardId) {
        this.Auth.clearAccountCache();
        var self = this;
        return this.$http.delete('api/account/payments/' + creditCardId)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('success response.....', response);
            }
            else {
                self.$log.error('api returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('error response.....', response);
            return response;
        });
    };
    CreditCardService.prototype.getCreditCardToUpdate = function (creditCard) {
        var updateCreditCard = {
            'cardNickName': creditCard.cardNickName,
            'cardType': this.getCardType(creditCard.cardType),
            'cardNumber': this.getCardNumber(creditCard.cardType),
            'expirationDate': creditCard.expirationDate,
            'dateCreated': creditCard.dateCreated,
            'dateLastChanged': creditCard.dateLastChanged,
            'dateLastUsed': creditCard.dateLastUsed,
            'nameOnCard': creditCard.nameOnCard,
            'firstName': creditCard.billingAddress.firstName !== null && creditCard.billingAddress.firstName !== '' ? creditCard.billingAddress.firstName : creditCard.cardNickName,
            'lastName': creditCard.billingAddress.lastName !== null && creditCard.billingAddress.lastName !== '' ? creditCard.billingAddress.lastName : creditCard.cardNickName,
            'address1': creditCard.billingAddress.line1,
            'address2': creditCard.billingAddress.line2,
            'city': creditCard.billingAddress.city,
            'state': creditCard.billingAddress.regionCode,
            'countryCode': creditCard.billingAddress.countryCode,
            'postalCode': creditCard.billingAddress.postalCode,
            'isDefaultPayment': creditCard.isDefaultPayment
        };
        if (creditCard.billingAddress.addressId) {
            updateCreditCard['addressId'] = creditCard.billingAddress.addressId;
        }
        return updateCreditCard;
    };
    CreditCardService.prototype.setDefaultCreditCard = function (creditCardId) {
        this.Auth.clearAccountCache();
        var self = this;
        return this.$http.put('api/account/payments/default/' + creditCardId)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('set default success response.....', response);
            }
            else {
                self.$log.error('set default api returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('error response.....', response);
            return response;
        });
    };
    CreditCardService.prototype.updateCreditCard = function (creditCard) {
        this.Auth.clearAccountCache();
        var self = this;
        var updatedCard = this.getCreditCardToUpdate(creditCard);
        return this.$http.put('api/account/payments/' + creditCard.creditCardId, updatedCard)
            .then(function success(response) {
            if (response.status == 200) {
                self.$log.debug('update credit card success response.....', response);
            }
            else {
                self.$log.error('update credit card returned other than 200 response.....', response);
            }
            return response;
        }, function error(response) {
            self.$log.error('update credit card error response.....', response);
            return response;
        });
    };
    CreditCardService.prototype.updateCreditCardNew = function (creditCard) {
        this.Auth.clearAccountCache();
        var updateCard = {
            "cardNickName": creditCard.nameOnCard,
            "cardType": creditCard.cardType.aresName,
            "expirationDate": "string",
            "nameOnCard": "string",
            "isDefaultPayment": true,
            "addressId": "string",
            "firstName": "string",
            "lastName": "string",
            "address1": "string",
            "address2": "string",
            "city": "string",
            "state": "string",
            "countryCode": "string",
            "postalCode": "string"
        };
        return this.$http.put('api/account/payments/' + creditCard.creditCardId, creditCard);
    };
    CreditCardService.prototype.validateName = function (event) {
        var specialChar = "!@#$%^&;*()+=-[]\\\;/{}|\":?_<>";
        if (specialChar.indexOf(event.key) != -1) {
            event.preventDefault();
        }
    };
    return CreditCardService;
}());
export default CreditCardService;
//# sourceMappingURL=credit-card.service.js.map